import { render, staticRenderFns } from "./CAARecordForm.vue?vue&type=template&id=462994a9&"
import script from "./CAARecordForm.vue?vue&type=script&lang=js&"
export * from "./CAARecordForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('462994a9')) {
      api.createRecord('462994a9', component.options)
    } else {
      api.reload('462994a9', component.options)
    }
    module.hot.accept("./CAARecordForm.vue?vue&type=template&id=462994a9&", function () {
      api.rerender('462994a9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/Shared/Domains/ZoneEditor/Records/CAARecordForm.vue"
export default component.exports